import $ from 'jquery';

/**
 * Increment steppers on steppers click
 * Stepper already has inline scripts to keep input to integer keys
 *
 * @class FormStepperView
 * @param {jQuery} [$trigger] Pass in containing dom element
 * @constructor
 */
export default class FormStepperView {
    constructor($stepperContainer) {
        if (!$stepperContainer) {
            throw ('Required $stepperContainer configuration object not passed to ToggleView constructor');
        }

        if (!$stepperContainer instanceof $) { // jshint ignore:line
            throw ('Required $stepperContainer object passed to ToggleView constructor is the wrong type');
        }
        // If view element isn't on the page
        if (!$stepperContainer.length) {
            return;
        }
        /**
         * A reference to the containing DOM element
         *
         * @property $stepperContainer
         * @type {jQuery}
         * @public
         */
        this.$stepperContainer = $stepperContainer;

        /**
         * Tracks whether the view is enabled
         *
         * @default false
         * @property isEnabled
         * @type {Boolean}
         * @public
         */
        this.isEnabled = false;

        this.init();
    };

    /**
     * Initializes the UI Component View
     *
     * @method init
     * @public
     * @chainable
     */
    init() {
        this.setupHandlers()
            .createChildren()
            .enable();
        return this;
    };


    /**
     * Binds the scope of any handler functions
     * Should only be run on initialization of the view
     *
     * @method setupHandlers
     * @public
     * @chainable
     */
    setupHandlers() {

        this.handleonButtonClick = this.onButtonClick.bind(this);

        return this;
    };


    /**
     * Create any child objects or references to DOM elements
     * Should only be run on initialization of the view
     *
     * @method createChildren
     * @public
     * @chainable
     */
    createChildren() {

        this.$decrement = this.$stepperContainer.find('.js-decrement');
        this.$increment = this.$stepperContainer.find('.js-increment');
        this.$stepperValue = this.$stepperContainer.find('.js-stepperValue');

        return this;
    };

    /**
     * Enables the component
     * Performs any event binding to handlers
     *
     * @method enable
     * @public
     * @chainable
     */
    enable() {
        if (this.isEnabled) {
            return this;
        }

        this.$decrement.on('click', (e) => this.handleonButtonClick(e, -1));
        this.$increment.on('click', (e) => this.handleonButtonClick(e, 1));

        this.isEnabled = true;
        return this;
    };
    /**
     * Disables the component
     * Tears down any event binding to handlers
     *
     * @method disable
     * @public
     * @chainable
     */
    disable() {
        if (!this.isEnabled) {
            return this;
        }

        this.$decrement.off('click');
        this.$increment.off('click');

        this.isEnabled = false;
        return this;
    };

    /**
     * Method onButtonClick
     *
     * @method onButtonClick 
     * @chainable
     * @public
     */
    onButtonClick(e, increment) {
        e.preventDefault();
        
        let current = parseInt(this.$stepperValue.val());

        let newValue = current + increment;

        this.$stepperValue.val(newValue > -1 ? newValue : 0);

        return this;
    }

}